import axios from '@/libs/axios'
import channels from './channels'
import content from './content'
import contentCategories from './contentCategories'
import posts from './posts'
import postTypes from './postTypes'
import resources from './resources'

/**
 * Vuex store for the Content Creator module (prefix: crtcreator).
 */
export default {
  namespaced: true,

  state: {
    module: null,
  },

  getters: {
    module(state) {
      return state.module
    },
    navigation(state) {
      return state.module?.navigation ?? []
    },
    isActive(state) {
      return Number(state.module?.active) === 1
    },
  },

  mutations: {
    SET_MODULE(state, value) {
      state.module = value
    },
  },

  actions: {
    loadModule({ commit }) {
      return axios.get('api/modules/crtcreator').then((response) => {
        const data = response.data?.data ?? response.data
        commit('SET_MODULE', data)
        return data
      })
    },
  },

  modules: {
    channels,
    content,
    contentCategories,
    posts,
    postTypes,
    resources,
  },
}
